<script>
import options from './StafetDonationStepVirksomhed.options'
export default options
</script>

<template>
  <article class="kb-stafet-step kb-stafet-donation-step-virksomhed kb-forms">
    <h2 class="kb-stafet-step__title">
      {{ labels.yourInformationCompanyTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <div class="kb-stafet-step__input-wrapper">
        <FormInputTextField
          v-model="companyName"
          fieldName="companyName"
          :modelValue="companyName"
          :label="labels.yourInformationCompanyNameLabel"
          :isRequired="true"
          :onChangeCallback="
            (e) => validateField('companyName', e.target.value)
          "
          :errorMessageLabel="labels.yourInformationCompanyNameErrorMessage"
          :isValidationError="showCompanyNameErrorMessage"
          :maxlength="50"
        />
      </div>

      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          v-model="firstName"
          fieldName="firstName"
          :modelValue="firstName"
          :label="labels.yourInformationFirstNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('firstName', e.target.value)"
          :errorMessageLabel="labels.yourInformationFirstNameErrorMessage"
          :isValidationError="showFirstNameErrorMessage"
        />

        <FormInputTextField
          v-model="lastName"
          fieldName="lastName"
          :modelValue="lastName"
          :label="labels.yourInformationLastNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('lastName', e.target.value)"
          :errorMessageLabel="labels.yourInformationLastNameErrorMessage"
          :isValidationError="showLastNameErrorMessage"
        />
      </div>

      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          v-model="email"
          fieldName="email"
          :modelValue="email"
          :label="labels.yourInformationEmailLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('email', e.target.value)"
          :errorMessageLabel="labels.yourInformationEmailErrorMessage"
          :isValidationError="showEmailErrorMessage"
        />

        <FormInputTextField
          v-model="phone"
          fieldName="phone"
          :modelValue="phone"
          :label="labels.yourInformationPhoneNumberLabel"
          :onChangeCallback="(e) => validateField('phone', e.target.value)"
          :errorMessageLabel="labels.yourInformationPhoneNumberErrorMessage"
          :isValidationError="showPhoneErrorMessage"
        />
      </div>

      <div class="kb-stafet-step__input-wrapper">
        
        <FormAddressField
          v-model:address-line-value="companyAddress"
          v-model:zip-code-value="companyPostalCode"
          v-model:city-value="companyCity"
          addressPlaceholder=""
          zipCodePlaceholder=""
          cityPlaceholder=""
          :addressLabel="labels.yourInformationCompanyAddressLabel"
          :zipCodeLabel="labels.yourInformationCompanyZipCodeLabel"
          :cityLabel="labels.yourInformationCompanyCityLabel"
          :errorMessageLabel="labels.yourInformationCompanyAddressErrorMessage"
          :isValidationError="showCompanyAddressErrorMessage"
        />

        <FormInputTextField
          v-if="donationFor === 'stafet'"
          v-model="companyWebsite"
          fieldName="companyWebsite"
          :modelValue="companyWebsite"
          :label="labels.yourInformationCompanyWebAddressLabel"
          :onChangeCallback="
            (e) => validateField('companyWebsite', e.target.value)
          "
          :errorMessageLabel="
            labels.yourInformationCompanyWebAddressErrorMessage
          "
        />
      </div>
    </div>

    <div v-if="donationFor === 'stafet'" class="kb-stafet-step__input-wrapper">
      <label class="kb-form__file-upload FormFileUpload" for="uploadLogo">
        <input
          class="kb-form__file-upload-input FormFileUpload__Input"
          id="uploadLogo"
          type="file"
          accept="image/png, image/jpg, image/jpeg, .svg"
          v-on:change="onFileChange"
        />
        <div class="kb-form__file-upload-svg">
          <svg
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity=".4" fill="#3C3C3C">
              <path
                d="m20.024 13.05.967-.405-.206-.481c-.84-2.002-.617-4.14.596-5.683 1.214-1.542 3.095-2.264 5.32-2.093l-1.49 1.438.73.75 2.016-1.961a1.008 1.008 0 0 0 0-1.44l-2.016-1.961-.73.75 1.396 1.357c-2.505-.133-4.674.757-6.049 2.518-1.451 1.856-1.72 4.375-.736 6.72l.203.49ZM18.141 24.419v1.046h-5.93v-1.046H.699v2.965a1.214 1.214 0 0 0 1.221 1.22h26.163a1.22 1.22 0 0 0 1.22-1.22v-2.965H18.142Zm10.116 2.965a.174.174 0 0 1-.174.174H1.92a.178.178 0 0 1-.125-.052.175.175 0 0 1-.05-.122v-1.919h9.42v1.047h8.023v-1.047h9.07v1.919ZM4.886 21.977H2.793V9.593a.174.174 0 0 1 .174-.174h14.128V8.372H2.967a1.22 1.22 0 0 0-1.22 1.221v13.43h3.139v-1.046Z"
              />
              <path
                d="M28.256 23.023V9.593a1.22 1.22 0 0 0-1.22-1.22h-4.013v1.046h4.012a.174.174 0 0 1 .174.174v13.43h1.047Z"
              />
            </g>
          </svg>
        </div>
        <div class="kb-form__file-upload-text-wrapper">
          <p class="kb-form__file-upload-text">
            {{ labels.yourInformationCompanyLogoLabel }}
          </p>
          <template v-if="companyLogo[0]">
            <p class="kb-form__file-upload-text-file">
              {{ companyLogo[0] ? companyLogo[0].name : '' }}
            </p>
          </template>
          <small class="kb-form__file-upload-format-types">{{
            labels.yourInformationCompanyLogoFileFormats
          }}</small>
        </div>
      </label>
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="isAnonymous"
        :modelValue="isAnonymous.toString()"
        v-model="isAnonymous"
        :label="labels.yourInformationAnonymousCheckbox"
        :errorMessageLabel="labels.yourInformationAnonymousCheckboxErrorMessage"
        :onChangeCallback="
          (e) => validateField('isAnonymous', e.target.checked)
        "
      />
      <FormCheckbox
        fieldName="taxDeduction"
        :modelValue="taxDeduction.toString()"
        v-model="taxDeduction"
        :label="labels.yourInformationTaxDeductionCheckbox"
        :errorMessageLabel="
          labels.yourInformationTaxDeductionCheckboxErrorMessage
        "
        :onChangeCallback="(e) => setTaxDeduction(e.target.checked)"
      />

      <FormInputTextField
        v-if="taxDeduction"
        v-model="cvr"
        fieldName="cvr"
        :modelValue="cvr"
        :label="labels.yourInformationCvrLabel"
        :isRequired="true"
        :maxlength="8"
        :errorMessageLabel="labels.yourInformationCvrErrorMessage"
        :onChangeCallback="(e) => validateField('cvr', e.target.value)"
        :isValidationError="showCvrErrorMessage"
      />
    </div>

    <StafetPayment
      :title="labels.yourInformationTotalTitle"
      :basket="basket"
      :inTotalLabel="labels.yourInformationTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationLastStep"
      :previousStepCallback="() => previousStepCallback(stepModel)"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
